export enum PERMISSIONS {
    CAN_ACCESS_FORMS = 'canAccessForms',
    CAN_ACCESS_HOME_MODULE = 'canAccessHomeModule',
    CAN_ACCESS_LIBRARY = 'canAccessLibrary',
    CAN_ACCESS_TASKS_AND_DECISIONS = 'canAccessTasksAndDecisions',
    CAN_ACCESS_TOPIC_HUB = 'canAccessTopicHub',
    CAN_ASSIGN_ALL_MEMBERS_TO_MY_GROUPS = 'canAssignAllMembersToMyGroups',
    CAN_ASSIGN_ANYONE_TO_MEETINGS = 'canAssignAnyoneToMeetings',
    CAN_ASSIST_MEMBERS = 'canAssistMembers',
    CAN_CREATE_DOCUMENTS = 'canCreateDocuments',
    CAN_CREATE_DOCUMENT_LABELS = 'canCreateDocumentLabels',
    CAN_CREATE_FORMS = 'canCreateForms',
    CAN_CREATE_GROUPS = 'canCreateGroups',
    CAN_CREATE_GUEST_MEMBERS = 'canCreateGuestMembers',
    CAN_CREATE_MEETINGS = 'canCreateMeetings',
    CAN_CREATE_MEMBERS = 'canCreateMembers',
    CAN_DELETE_ALL_GROUPS = 'canDeleteAllGroups',
    CAN_DELETE_ALL_MEMBERS = 'canDeleteAllMembers',
    CAN_GRANT_SUPER_POWERFUL_PERMISSIONS = 'canGrantSuperPowerfulPermissions',
    CAN_MANAGE_ALL_CONTENT = 'canManageAllContent',
    CAN_MANAGE_GROUP_TOPIC_HUB = 'canManageGroupTopicHub',
    CAN_MANAGE_SELF = 'canManageSelf',
    CAN_READ_ALL_GROUPS = 'canReadAllGroups',
    CAN_READ_ALL_MEMBERS = 'canReadAllMembers',
    CAN_READ_DOCUMENT_LABELS = 'canReadDocumentLabels',
    CAN_UPDATE_ALL_GROUPS = 'canUpdateAllGroups',
    CAN_UPDATE_ALL_MEMBERS = 'canUpdateAllMembers',
    CAN_UPDATE_DOCUMENTS = 'canUpdateDocuments',
    CAN_UPDATE_DOCUMENT_LABELS = 'canUpdateDocumentLabels',
    CAN_UPDATE_MEETINGS = 'canUpdateMeetings',
    CAN_UPDATE_ROOM_SETTINGS = 'canUpdateRoomSettings',
    IS_ASSIGNABLE_AS_GROUP_MANAGER_TO_GROUPS = 'isAssignableAsGroupManagerToGroups',
    IS_ASSIGNABLE_AS_NON_GUEST_TO_MEETINGS = 'isAssignableAsNonGuestToMeetings',
    IS_ASSIGNABLE_TO_GROUPS = 'isAssignableToGroups',
    IS_ASSISTABLE = 'isAssistable',
    REQUIRES_CLASSIFICATION_LEVEL = 'requiresClassificationLevel'
}

export enum ORGANISATION_PERMISSIONS {
    CAN_AUDIT_ROOMS = 'canAuditRooms',
    CAN_MANAGE_USERS = 'canManageUsers',
    CAN_REMOVE_ENCRYPTION_KEYS = 'canRemoveEncryptionKeys',
    CAN_VIEW_INVOICES = 'canViewInvoices'
}

export enum PERMISSION_SETS {
    ADMIN = 'admin_role',
    ASSISTANT = 'assistant',
    CONTRIBUTOR = 'contributor_role',
    DEFAULT_MEMBER = 'default_member',
    DEFAULT_MEMBER_CAN_MANAGE_ALL_MEMBERS_ALL_GROUPS_ALL_CONTENT = 'default_member_and_can_manage_all_members_all_groups_all_content',
    DEFAULT_MEMBER_CAN_MANAGE_ALL_MEMBERS_AND_GROUPS = 'default_member_and_can_manage_all_members_and_groups',
    DEFAULT_MEMBER_CAN_MANAGE_GROUPS_I_AM_MANAGER_OF = 'default_member_and_can_manage_groups_i_am_manager_of',
    DOWNLOAD_DOCUMENTS_FROM_NATIVE_APPS = 'download_documents_from_native_apps',
    EDITOR = 'editor_role',
    GROUP_MANAGER = 'group_manager_role',
    GUEST = 'guest',
    MEMBER = 'member_role',
    MINUTES_VIEWER = 'minutes_viewer',
    OLD_ASSISTANT = 'assistant_role',
    RESTRICTED_MEMBER = 'restricted_member',
    USER_MANAGER = 'user_manager_role'
}

export type PermissionSet = {
    id: PERMISSION_SETS;
    enabledInRoom: boolean;
    isBase: boolean;
    permissions: Record<PERMISSIONS, boolean>;
};
